import { trait, relation } from 'koota';

export const ChildOf = relation();
export const Input = trait({ x: 0, y: 0 });
